import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'

type UsePrintProductMutationProps = {
	handlePrintComponent: () => void
	onSettled: () => void
}

export const usePrintProductMutation = ({
	handlePrintComponent,
	onSettled
}: UsePrintProductMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: printProductMutation } = useMutation({
		mutationFn: ({ id, quantity }: { id: number; quantity: number | undefined }) => {
			handlePrintComponent()
			const printed = {
				id,
				quantity
			}
			return axiosPrivate.post(apiRoutes.productsPrint, { products: [printed] })
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.products.all })
			useToast({
				type: 'success',
				message: t('Product printed')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		printProductMutation
	}
}
